import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn'; // Assuming we might need a utility, but I'll implement inline for now to be safe or create a util if I had one. I'll stick to template literals for simplicity.
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-brand-primary text-white hover:bg-[#7A6B8C] shadow-md hover:shadow-lg',
    secondary: 'bg-brand-accent/20 text-brand-primary hover:bg-brand-accent/30',
    outline: 'border-2 border-brand-primary text-brand-primary hover:bg-brand-primary/5'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-132">
      {children}
    </motion.button>;
}